import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Input } from "semantic-ui-react";
import { Formik, Form } from "formik";
import { handleNewPassword } from "../../state/auth/actions";
import {
  BoxForm,
  FormContainer,
  Logo,
  Title,
  LoginContainer,
  Label,
  Checkers,
} from "./styles";
import Loading from "../../components/LoadingTemplate/index";
import { toastAlert } from "../../components/Toastify/index";
import LogoZaivu from "../../assets/Logo-Zaivu.svg";
import Button from "../../components/general/Button";

const ResetPasswordPage = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const resetToken = match.params.token;
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/;

  useEffect(() => {
    if (token) {
      toastAlert({
        msg: "ERRO: Deslogue da conta antes de abrir o link!",
        isError: true,
      });
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, token]);

  const handleSubmit = (values) => {
    setLoading(true);
    dispatch(handleNewPassword({ password: values.password, resetToken })).then(
      () => {
        toastAlert({
          msg: "Senha redefinida com sucesso!",
          isError: false,
        });
        history.push("/login");
      },
    );
  };

  return !loading ? (
    <BoxForm>
      <Formik
        initialValues={{
          password: "",
          newPassword: "",
        }}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, values, handleChange }) => (
          <Form onSubmit={handleSubmit}>
            <LoginContainer>
              <Logo src={LogoZaivu} />
              <Title>Redefinir senha</Title>
              <FormContainer>
                <Label>Nova senha</Label>
                <Input
                  icon="lock"
                  iconPosition="left"
                  style={{ marginBottom: "10px" }}
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Senha"
                  value={values.password}
                  onChange={handleChange}
                />
                <Label>Confirmar nova senha</Label>
                <Input
                  icon="lock"
                  iconPosition="left"
                  style={{ marginBottom: "10px" }}
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  placeholder="Confirmar senha"
                  value={values.newPassword}
                  onChange={handleChange}
                />
                {/* Checker Components */}
                {/* Assuming Checkers is a styled component or functional component that displays its children if the `check` prop is false */}
                <Checkers check={regex.test(values.password)}>
                  Senha deve ter no mínimo 8 caracteres, conter pelo menos uma
                  letra maiúscula, uma letra minúscula e um número
                </Checkers>
                <Checkers check={values.password === values.newPassword}>
                  As novas senhas devem ser iguais
                </Checkers>

                <Button
                  disabled={
                    values.password !== values.newPassword ||
                    values.password === "" ||
                    !regex.test(values.password)
                  }
                  type="submit"
                  content={"Redefinir senha"}
                />
              </FormContainer>
            </LoginContainer>
          </Form>
        )}
      </Formik>
    </BoxForm>
  ) : (
    <div>
      <Loading />
    </div>
  );
};

export default ResetPasswordPage;
